import { render, staticRenderFns } from "./herders.vue?vue&type=template&id=4af4ef36&scoped=true"
import script from "./herders.vue?vue&type=script&lang=js"
export * from "./herders.vue?vue&type=script&lang=js"
import style0 from "./herders.vue?vue&type=style&index=0&id=4af4ef36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af4ef36",
  null
  
)

export default component.exports